import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './about-city.styles';

const AboutCity = props => {
  const { title, longDesc, isDweb = false, shouldBeH1 = false, isH1Header = false } = props;
  return (
    <C.Wrap isDweb={isDweb}>
      <S.Details>
        {shouldBeH1 ? (
          <h1 style={isH1Header ? { fontSize: '1.8em' } : {}}>{title}</h1>
        ) : (
          <h2>{title}</h2>
        )}
        <div dangerouslySetInnerHTML={{ __html: longDesc }}></div>
      </S.Details>
    </C.Wrap>
  );
};

export default AboutCity;
